// Client-safe type definition for ChannelMappingV2
export interface ChannelMappingType {
  id?: string
  orgId?: string
  workspaceId?: string
  source?: string
  medium?: string
  channel?: string
}

// [source, medium, channel]
export const defaultChannelMappings = [
  // 1. Direct
  [`direct`, `(not set)`, `Direct`],
  [`direct`, `direct`, `Direct`],

  // 2. Organic Search
  [`google`, `organic`, `Organic Search`],
  [`google organic`, `organic`, `Organic Search`],
  [`bing`, `organic`, `Organic Search`],
  [`yahoo`, `organic`, `Organic Search`],
  [`duckduckgo`, `organic`, `Organic Search`],
  [`google`, `search`, `Organic Search`],
  [`yahoo organic`, `organic`, `Organic Search`],
  [`yahoo`, `search`, `Organic Search`],
  [`bing organic`, `organic`, `Organic Search`],

  // 3. Paid Search
  [`google`, `cpc`, `Paid Search`],
  [`google`, `ppc`, `Paid Search`],
  [`google`, `cpm`, `Paid Search`],
  [`google`, `paid`, `Paid Search`],
  [`bing`, `cpc`, `Paid Search`],
  [`bing`, `ppc`, `Paid Search`],
  [`bing`, `cpm`, `Paid Search`],
  [`bing`, `paid`, `Paid Search`],
  [`google ads`, `cpc`, `Paid Search`],
  [`google ads`, `ppc`, `Paid Search`],
  [`google ads`, `cpm`, `Paid Search`],
  [`google ads`, `paid`, `Paid Search`],
  [`google`, `ppl`, `Paid Search`],

  // 4. Organic Social
  [`facebook`, `referral`, `Organic Social`],
  [`instagram`, `referral`, `Organic Social`],
  [`twitter`, `referral`, `Organic Social`],
  [`linkedin`, `referral`, `Organic Social`],

  // 5. Paid Social
  [`facebook`, `cpc`, `Paid Social`],
  [`facebook`, `paid social`, `Paid Social`],
  [`facebook`, `paid`, `Paid Social`],
  [`facebook`, `cpm`, `Paid Social`],
  [`facebook`, `ppc`, `Paid Social`],
  [`fb`, `cpc`, `Paid Social`],
  [`fb`, `paid social`, `Paid Social`],
  [`fb`, `paid`, `Paid Social`],
  [`fb`, `cpm`, `Paid Social`],
  [`fb`, `ppc`, `Paid Social`],
  [`instagram`, `cpc`, `Paid Social`],
  [`instagram`, `paid social`, `Paid Social`],
  [`instagram`, `paid`, `Paid Social`],
  [`instagram`, `cpm`, `Paid Social`],
  [`instagram`, `ppc`, `Paid Social`],
  [`linkedin`, `cpc`, `Paid Social`],
  [`linkedin`, `paid social`, `Paid Social`],
  [`linkedin`, `paid`, `Paid Social`],
  [`linkedin`, `cpm`, `Paid Social`],
  [`linkedin`, `ppc`, `Paid Social`],
  [`twitter`, `cpc`, `Paid Social`],
  [`twitter`, `paid social`, `Paid Social`],
  [`twitter`, `paid`, `Paid Social`],
  [`twitter`, `cpm`, `Paid Social`],
  [`twitter`, `ppc`, `Paid Social`],
  [`tiktok`, `cpc`, `Paid Social`],
  [`tiktok`, `paid social`, `Paid Social`],
  [`tiktok`, `paid`, `Paid Social`],
  [`tiktok`, `cpm`, `Paid Social`],
  [`tiktok`, `ppc`, `Paid Social`],
  [`snapchat`, `cpc`, `Paid Social`],
  [`snapchat`, `paid social`, `Paid Social`],
  [`snapchat`, `paid`, `Paid Social`],
  [`snapchat`, `cpm`, `Paid Social`],
  [`snapchat`, `ppc`, `Paid Social`],

  // 6. Referral
  [`referral`, `patient`, `Referral`],

  // 7. Display
  [`google`, `display`, `Display`],
  [`google`, `cpm`, `Display`],
  [`google_display`, `display`, `Display`],
  [`google_display`, `cpm`, `Display`],
  [`doubleclick`, `display`, `Display`],
  [`doubleclick`, `cpm`, `Display`],
  [`criteo`, `display`, `Display`],
  [`criteo`, `cpm`, `Display`],
  [`taboola`, `display`, `Display`],
  [`taboola`, `cpm`, `Display`],
  [`outbrain`, `display`, `Display`],
  [`outbrain`, `cpm`, `Display`],

  // 8. Paid Video
  [`youtube`, `video`, `Paid Video`],
  [`tiktok`, `video`, `Paid Video`],

  // 9. Print
  [`print`, `mailer`, `Print`],
]

export const defaultChannels = Array.from(
  new Set([...defaultChannelMappings.map(([, , channel]) => channel), `Email`]),
).sort()
